'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback } from 'react';
import { getCoreProps } from '../core/core.utils.js';
import { noTooltipInternal } from '../icon-button/icon-button-internal.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { TextInput } from '../text-input/text-input.component.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const SearchInput = renderWithRef('SearchInput', null, (s, b)=>{
    let f = useRef(void 0), m = assignRefs(b, f), { skin: _ = 'standard', disabled: y, onClear: d, onSearchSubmit: j, accessibleTextForClearButton: O, accessibleTextForSearchButton: w } = s, h = _object_without_properties(s, [
        "skin",
        "disabled",
        "onClear",
        "onSearchSubmit",
        "accessibleTextForClearButton",
        "accessibleTextForSearchButton"
    ]), g = getCoreProps(h), P = useCallback((e)=>{
        f.current && (f.current.value = '', f.current.focus()), d && d(e);
    }, [
        d
    ]), v = new Set([
        'swan-search-input'
    ]);
    return 'error' === _ && v.add('swan-search-input-skin-error'), jsxs(RenderComp, {
        root: "div",
        classNames: v,
        props: _object_spread({}, g),
        children: [
            jsx(RenderComp, {
                forwardedRef: m,
                root: TextInput,
                props: _object_spread({
                    type: 'search',
                    disabled: y
                }, h)
            }),
            jsx(IconButton, _object_spread_props(_object_spread({
                className: "swan-search-input-clear",
                skin: "tertiary",
                onClick: P,
                "aria-label": O,
                disabled: y,
                tooltip: ""
            }, noTooltipInternal), {
                children: jsx(Icon, {
                    iconType: "clear"
                })
            })),
            jsx("span", {
                className: "swan-search-divider"
            }),
            jsx(IconButton, _object_spread_props(_object_spread({
                type: "submit",
                skin: "tertiary",
                className: "swan-search-input-submit",
                onClick: null != j ? j : void 0,
                "aria-label": w,
                disabled: y,
                tooltip: ""
            }, noTooltipInternal), {
                children: jsx(Icon, {
                    iconType: "search"
                })
            }))
        ]
    });
});

export { SearchInput };
